import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    assignGroupMemberBulk,
    getUserGroupUpdateProgress,
    stopUserGroupBulkUpdate,
} from 'src/openapi/admin/apis/BulkGroupAssignApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    GROUP_MODAL_TITLES,
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    UNASSIGN_MODAL_WIDTH,
} from '../constants';
import {
    selectUpdateUserGroupTask,
    selectUpdateUserGroupUuid,
    setBackgroundTask,
    setShown,
    setUuid,
} from '../update-user-group.slice';

import {UnassignFromGroupModal} from './unassign-from-group.modal';

import type {UpdateUserGroup} from 'src/openapi/admin/models/UpdateUserGroup';

type Props = {
    userIds: number[],
    onDone: () => void,
    shown: boolean,
    onClose: () => void,
};

export const UnassignFromGroupTool = ({shown, userIds, onDone, onClose}: Props) => {
    const apiDispatch = useAppDispatch();

    return (
        <BulkActionTool<UpdateUserGroup[]>
            shown={shown}
            onClose={onClose}
            width={UNASSIGN_MODAL_WIDTH}
            toolTask={TOOL_TASK}
            toolName={GROUP_MODAL_TITLES.UNASSIGN}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={selectUpdateUserGroupTask}
            uuidSelector={selectUpdateUserGroupUuid}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(updateUserGroup, options) => (
                apiDispatch(assignGroupMemberBulk({...options, updateUserGroup}))
            )}
            getProgress={id => apiDispatch(getUserGroupUpdateProgress({id}))}
            stopAction={id => apiDispatch(stopUserGroupBulkUpdate({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={onDone}>
            {({onCloseModal, processAction}) => (
                <UnassignFromGroupModal {...{userIds, onCloseModal, processAction}}/>
            )}
        </BulkActionTool>
    );
};
